import { render, staticRenderFns } from "./gallerycompare.component.html?vue&type=template&id=d3eda8e4&scoped=true&"
import script from "./gallerycompare.component.ts?vue&type=script&lang=ts&"
export * from "./gallerycompare.component.ts?vue&type=script&lang=ts&"
import style0 from "./gallerycompare.component.scss?vue&type=style&index=0&id=d3eda8e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3eda8e4",
  null
  
)

export default component.exports